module.exports = __webpack_public_path__ + "img/LocalShippingOutlined.4da4e907.svg";